import { combineEpics, ofType } from "redux-observable"
import { Epic } from "../../epics"

import * as actions from "./actions"
import { debounceTime, delay, flatMap, mergeMap } from "rxjs/operators"
import { EMPTY, of } from "rxjs"
import { removeQueryParam, setQueryParam } from "../../util/Url"
import { getTerm } from "./selectors"
import { ContextualHelpTerm } from "../../models"

export const filterTermsEpic: Epic = (action$, _state$) =>
    action$.pipe(
        ofType(actions.FILTER_TERMS),
        debounceTime(500),
        mergeMap(() => of(actions.setDictionaryLoading(false))),
    )

export const selectTermInDictionaryEpic: Epic = (action$, state$) =>
    action$.pipe(
        ofType(actions.SELECT_TERM_IN_DICTIONARY),
        flatMap(() => {
            const {
                contextualHelp: {
                    dictionaryPopup: { selectedTermCode },
                },
            } = state$.value
            if (selectedTermCode) {
                setQueryParam("dictionary", selectedTermCode)
            }
            return EMPTY
        }),
    )

const maxRetries = 5
const retryInterval = 1000

export const tryTriggerTooltipEpic: Epic = (action$, state$) =>
    action$.pipe(
        ofType(actions.TRY_TRIGGER_TOOLTIP),
        flatMap(({ termCode, count }: actions.TryTriggerTooltip) => {
            const { contextualHelp } = state$.value
            const term = getTerm(contextualHelp, termCode)

            if (!term || !term.target) {
                return EMPTY
            }

            const tooltipElement = document.querySelector(term.target)
            if (tooltipElement === null) {
                if (count >= maxRetries) {
                    return EMPTY
                } else {
                    return of(
                        actions.tryTriggerTooltip(termCode, ++count),
                    ).pipe(delay(retryInterval))
                }
            }

            return of(actions.triggerTooltip(term as ContextualHelpTerm))
        }),
    )

export const updateDictionaryPopupVisibilityEpic: Epic = (action$, state$) =>
    action$.pipe(
        ofType(actions.UPDATE_DICTIONARY_POPUP_VISIBILITY),
        flatMap(() => {
            const {
                contextualHelp: { isDictionaryPopupVisible },
            } = state$.value
            if (!isDictionaryPopupVisible) {
                removeQueryParam("dictionary")
            }
            return EMPTY
        }),
    )

export default combineEpics(
    tryTriggerTooltipEpic,
    filterTermsEpic,
    selectTermInDictionaryEpic,
    updateDictionaryPopupVisibilityEpic,
)
